import React from 'react';
import { cn } from '@/lib/utils';

/**
 * Bayenah Mark (Brand v1 — May 13 2026)
 *
 * The mark is supplied as PNG with transparent background in two color
 * variants — black for light surfaces, white for dark surfaces. The
 * landing page renders the bilingual lockup separately; this component
 * is mark-only.
 */

export const LOGO_SIZES = {
  header: 40,
  headerMobile: 32,
  sidebar: 28,        // Brand v1 — 28px mark-only in the app sidebar
  sidebarCompact: 24,
  hero: 96,           // Used for in-product accents only — landing has its own lockup
  heroMobile: 72,
  small: 32,
  tiny: 20,
};

export const BayenahLogo = ({
  className,
  height = LOGO_SIZES.sidebar,
  clickable = false,
  onClick,
  variant = 'dark',   // 'dark' = black mark (light surface), 'light' = white mark (dark surface)
  ...props
}) => {
  const src = variant === 'light' ? '/brand/mark-white.png' : '/brand/mark-black.png';

  const handleClick = () => { if (clickable && onClick) onClick(); };
  const handleKeyDown = (e) => {
    if (clickable && onClick && (e.key === 'Enter' || e.key === ' ')) {
      e.preventDefault();
      onClick();
    }
  };

  return (
    <img
      src={src}
      alt="Bayenah"
      className={cn(
        'bayenah-mark select-none object-contain',
        clickable && 'cursor-pointer hover:opacity-75 transition-opacity',
        className,
      )}
      style={{ height: `${height}px`, width: 'auto' }}
      onClick={handleClick}
      onKeyDown={handleKeyDown}
      tabIndex={clickable ? 0 : undefined}
      role={clickable ? 'button' : undefined}
      aria-label={clickable ? 'Bayenah — Home' : 'Bayenah'}
      data-testid="bayenah-logo"
      draggable={false}
      {...props}
    />
  );
};

export default BayenahLogo;
